// Normal page navigation on all devices avoids cross-document animation work.
// The CSS navigation opt-out also prevents browser transition snapshots.
(function () {
  document.getElementById('view-transition-render-blocker')?.remove();
})();
